( function () {
    'use strict';
    e.searching = {
        init: function () {
            if ( e.util.param.q !== undefined ) {
                //hvis der bliver s&oslash;gt sættes cursoren i s&oslash;gefeltet
                jQuery( '.form-search' ).first().find( 'input[name="q"]' ).focus().select();
                if ( !isNaN( parseInt( e.util.param.searchpage ) ) ) {
                    jQuery( '.e-search, .form-search, .navbar-search' ).find( 'input[name="ID"]' ).val( e.util.param.searchpage );
                }
            }
            e.searching.buildPaging();
            e.searching.suggest.init();
            e.searching.nav();
            e.searching.span();
        },
        query: '',
        suggest: {
            init: function () {
                jQuery( '.js-e-suggest' ).prop( 'autocomplete', 'off' ).typeahead( {
                    menu: '<ul class="container typeahead dropdown-menu js-e-typeahead-dropdown"></ul>',
                    minlength: 3,
                    items: 8,
                    source: function ( query, process ) {
                        return jQuery.ajax( {
                            url: '/json-suggested-search',
                            data: {
                                q: query,
                                limit: 8
                            },
                            dataType: 'json',
                        } ).done( function ( data ) {
                            e.searching.query = query;
                            e.searching.suggest.pages = [];
                            e.searching.suggest.pageMap = {};
                            jQuery.each( data.results, function ( index, page ) {
                                e.searching.suggest.pageMap[ page.header ] = page;
                                e.searching.suggest.pages.push( page.header );
                            } );
                            if ( e.searching.suggest.pages.length > 0 ) {
                                //Skjul fejlbesked
                                //e.ecom.quick.jOrderForm.find( '.js-e-msg-no-result' ).hide();
                            }
                            return process( e.searching.suggest.pages, e.searching.appendCategories );
                        } );
                    },
                    render: function ( items ) {
                        var that = this;
                        items = $( items ).map( function ( i, item ) {
                            i = $( that.options.item ).attr( 'data-value', item );
                            i.find( 'a' ).html( that.highlighter( item ) );
                            return i[ 0 ];
                        } );
                        this.$menu.html( items );
                        return this;
                    },
                    sorter: function ( items ) {
                        //console.log( items.length );
                        return items;
                    },
                    highlighter: function ( items ) {
                        var i = e.searching.suggest.pageMap[ items ],
                            item = '<span data-category="' + i.category + '" data-label="' + i.categorylabel + '">' + e.searching.highlighted( items ) + '</span>';
                        return item;
                    },
                    matcher: function () {
                        return true;
                    },
                    updater: function ( item ) {
                        //console.log( this.query );
                        if ( item !== undefined ) {
                            location.href = e.searching.suggest.pageMap[ item ].url;
                            return this.query;
                        }
                        else {
                            jQuery( '.espresso-searchbar' ).find( '.js-e-suggest' ).val( this.query ).parents( 'form' ).submit();
                        }
                    }
                } );
            }
        },
        highlighted: function ( item ) {
            var query = e.searching.query.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&' );
            return item.replace( new RegExp( '(' + query + ')', 'ig' ), function ( $1, match ) {
                return '<strong>' + match + '</strong>';
            } );
        },
        appendCategories: function () {
            //console.log('sdf');
            var jDropdown = jQuery( '.js-e-typeahead-dropdown' ),
                jPage = jDropdown.find( 'span[data-category="page"]' ).first(),
                jProduct = jDropdown.find( 'span[data-category="product"]' ).first();
            jPage.parents( 'li' ).addClass( 'typeahead-category-page' ).attr( 'data-label', jPage.data( 'label' ) );
            jProduct.parents( 'li' ).addClass( 'typeahead-category-product' ).attr( 'data-label', jProduct.data( 'label' ) );
            //jDropdown.find( 'li' ).last().after( '<li class=""><a class="typeahead-see-all" href="#">Se alle sider/produkter <i class="icon-angle-right pull-right"></i></a></li>' );
        },
        buildPaging: function () {
            //byg bootstrap markup af dw's default paging
            var jSearchPaging = jQuery( '.pagination' );
            if ( jSearchPaging.length === 1 ) {
                jQuery( '.page-list a' ).wrap( function () {
                    var jListItem = jQuery( '<li></li>' );
                    if ( jQuery( this ).find( 'b' ).length > 0 ) {
                        return jListItem.addClass( 'active' );
                    }
                    else {
                        return jListItem;
                    }
                } );
                jSearchPaging.find( 'li' ).first().after( jQuery( '.page-list li' ) );
            }
        }
    };
    e.searching.span = function () {
        if ( !jQuery( '.js-productlist-pages-empty' ).find( 'div' ).length ) {
            jQuery( '.js-productlist-products-empty' ).toggleClass( ' span9 span12 ' );
        }
        if ( !jQuery( '.js-productlist-products-empty' ).find( 'div' ).length ) {
            jQuery( '.js-productlist-pages-empty' ).toggleClass( ' span3 span12 ' );
        }
    };
    e.searching.nav = function () {
        jQuery( '.js-espresso-search-toggle' ).click( function () {
            jQuery( '.espresso-searchbar' ).animate( {
                width: 'toggle'
            }, 250 );
            jQuery( '.espresso-searchbar input[type="text"]' ).select();
            jQuery( '.espresso-searchbar input[type="text"]' ).val( '' );
            jQuery( document ).bind( 'focusin.espresso-searchbar click.espresso-searchbar', function ( e ) {
                if ( jQuery( e.target ).closest( '.espresso-searchbar, .js-espresso-search-toggle' ).length ) {
                    return;
                }
                jQuery( document ).unbind( '.espresso-searchbar' );
                jQuery( '.espresso-searchbar' ).fadeOut( 250 );
            } );
        } );
    };
}() );
